import { Circle } from '../types/Circle.ts';
import { Position } from './Position';
import { RelativeRadius } from './RelativeRadius';

export class DashedCircle implements Circle {
    constructor(
        private ctx: CanvasRenderingContext2D,
        private position: Position,
        private radius: RelativeRadius,
        private color: string,
        private lineWidth: number,
        private dashPattern: number[]
    ) {}

    draw(): void {
        this.ctx.beginPath();
        this.ctx.setLineDash(this.dashPattern);
        this.ctx.strokeStyle = this.color;
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.arc(this.position.x, this.position.y, this.radius.radius(), 0, Math.PI * 2);
        this.ctx.stroke();
        this.ctx.setLineDash([]); // Reset dash after drawing
    }
} 